import { useCallback } from "react";
import { useAlertContext, type AlertProps } from "@shared/ui.components";

export const usePromoMessage = () => {
  const alertContext = useAlertContext();

  const showMessage = useCallback(
    (message: AlertProps) => {
      if (!alertContext) return;

      // Ensure dismissible is set to true for messages with titles
      const alertProps = message.title
        ? { ...message, dismissible: true as const }
        : message;

      alertContext.showAlert(alertProps);
    },
    [alertContext]
  );

  return showMessage;
};

export const usePromoAlert = () => {
  const alertContext = useAlertContext();
  const showMessage = usePromoMessage();

  return {
    showMessage,
    hasAlert: !!alertContext?.alert,
    alert: alertContext?.alert || null
  };
};
